/**
 * @file
 * Karhu Helsinki - Sodexo Theme JavaScripts
 */

(function ($, Drupal) {

  // jQuery 4.x compatibility polyfills for deprecated methods
  if (typeof $.camelCase === 'undefined') {
    $.camelCase = function(string) {
      return string.replace(/-([a-z])/g, function(match, letter) {
        return letter.toUpperCase();
      });
    };
  }

  // Matching heights
  $(window).on("resize load", function () {
    // Campaign page highlights
    if ($(window).width() > 940 && $(window).width() < 1440) {
      var rows = $.fn.matchHeight._rows($(".field--name-field-highlights>.field__item .field--name-field-image img"));

      $.each(rows, function (i, row) {
        var matchTarget = row.closest(".paragraph--type--highlight").find(".field--name-field-body");
        row.matchHeight({
          target: matchTarget
        });
      });
    } else {
      var rows = $.fn.matchHeight._rows($(".field--name-field-highlights>.field__item .field--name-field-image img"));

      $.each(rows, function (i, row) {
        var matchTarget = row.closest(".paragraph--type--highlight").find(".field--name-field-body");
        row.matchHeight({
          remove: true
        });
      });
    }
  }).resize();


  Drupal.behaviors.sodexo = {
    frontPageHero: function (context) {
      $(window).on("resize load", function () {
        if ($(window).width() > 1184) {
          $(".front-page-hero").css("height", $(window).height());
        } else {
          $(".front-page-hero").css("height", "auto");
        }
      }).resize();
    },

    frontPageListings: function (context) {
      $(window).on("resize load", function () {
        // News and Campaign highlights on front page
        if ($(window).width() > 719 && $(window).width() < 1440) {
          var rows = $.fn.matchHeight._rows($(".view-display-id-recent_nc_higlights .views-row .field--name-field-header-image img"));

          $.each(rows, function (i, row) {
            var matchTarget = row.closest(".link-wrapper").find(".text-wrapper");
            row.matchHeight({
              target: matchTarget
            });
          });
        } else {
          var rows = $.fn.matchHeight._rows($(".view-display-id-recent_nc_higlights .views-row .field--name-field-header-image img"));

          $.each(rows, function (i, row) {
            var matchTarget = row.closest(".link-wrapper").find(".text-wrapper");
            row.matchHeight({
              remove: true
            });
          });
        }
      }).resize();
    },

    newsPageListing: function (context) {
      $(window).on("resize load", function () {
        // News and Campaign highlights on front page
        if ($(window).width() > 719 && $(window).width() < 1440) {
          var rows = $.fn.matchHeight._rows($(".view-display-id-recent_news .views-row .field--name-field-header-image img"));

          $.each(rows, function (i, row) {
            var matchTarget = row.closest(".link-wrapper").find(".text-wrapper");
            row.matchHeight({
              target: matchTarget
            });
          });
        } else {
          var rows = $.fn.matchHeight._rows($(".view-display-id-recent_news .views-row .field--name-field-header-image img"));

          $.each(rows, function (i, row) {
            var matchTarget = row.closest(".link-wrapper").find(".text-wrapper");
            row.matchHeight({
              remove: true
            });
          });
        }
      }).resize();
    },

    newsCampaignListing: function (context) {
      $(window).on("resize load", function () {
        // News and Campaign highlights on front page
        if ($(window).width() > 719 && $(window).width() < 1440) {
          var rows = $.fn.matchHeight._rows($(".view-display-id-news_listing_highlights .views-row .field--name-field-header-image img"));

          $.each(rows, function (i, row) {
            var matchTarget = row.closest(".link-wrapper").find(".text-wrapper");
            row.matchHeight({
              target: matchTarget
            });
          });
        } else {
          var rows = $.fn.matchHeight._rows($(".view-display-id-news_listing_highlights .views-row .field--name-field-header-image img"));

          $.each(rows, function (i, row) {
            var matchTarget = row.closest(".link-wrapper").find(".text-wrapper");
            row.matchHeight({
              remove: true
            });
          });
        }
      }).resize();
    },

    restaurantNCListing: function (context) {
      $(window).on("resize load", function () {
        // News and Campaign highlights on restaurant and landing pages
        if ($(window).width() > 719 && $(window).width() < 1440) {
          var rows = $.fn.matchHeight._rows($(".view-display-id-restaurant_recent_nc_highlights .views-row .field--name-field-header-image img"));

          $.each(rows, function (i, row) {
            var matchTarget = row.closest(".link-wrapper").find(".text-wrapper");
            row.matchHeight({
              target: matchTarget
            });
          });
        } else {
          var rows = $.fn.matchHeight._rows($(".view-display-id-restaurant_recent_nc_highlights .views-row .field--name-field-header-image img"));

          $.each(rows, function (i, row) {
            var matchTarget = row.closest(".link-wrapper").find(".text-wrapper");
            row.matchHeight({
              remove: true
            });
          });
        }
      }).resize();
    },

    rtMenu: function (context) {
      $(window).on("resize load", function () {
        if ($(window).width() < 1200) {
          $(".rt-menu-toggle").click(function () {
            $(".rt-menu").toggle();
          });
        } else {
          $(".rt-menu-toggle").off("click");
          $(".rt-menu").css({ display: "" });
        }
      });
    },

    restaurantPage: function (context) {
      $(document).ready(function () {
        // Check if restaurant page image gallery has content
        if (!($('.media-wrapper .owl-carousel .owl-stage').html() || '').trim().length) {
          $('.media-wrapper #gallery-button').removeClass('active').addClass('empty');
          $('.media-wrapper .image-gallery').removeClass('active');
          $('.media-wrapper #video-button').addClass('active');
          $('.media-wrapper .video-highlight').addClass('active');
        };

        if (!($('.media-wrapper .owl-carousel .owl-stage').html() || '').trim().length && !($('.media-wrapper .video-highlight').html() || '').trim().length) {
          $('.media-wrapper').addClass('empty');
        };

        $('#block-entityviewcontent-restaurant-other-services').each(function () {
          if ($('#block-entityviewcontent-restaurant-other-services .services-wrapper').hasClass('empty')) {
            $(this).addClass('empty');
          }
        });

        if (!($('.open-hours-wrapper .restaurant-part').html() || '').trim().length) {
          $('.open-hours-wrapper').addClass('one-part');
        } else {
          $('.open-hours-wrapper').removeClass('one-part');
        }

      });

      $(window).on("resize load", function () {
        if ($(window).width() >= 720 && ($('.media-wrapper .owl-carousel .owl-stage').html() || '').trim()) {
          $('.video-highlight').hide();

          $('#video-button').on('click', function () {
            $("#gallery-button.active").removeClass("active");
            $("#video-button").addClass("active");
            $('.video-highlight').show();
            $('.image-gallery').hide();
          });

          $('#gallery-button').on('click', function () {
            $("#video-button.active").removeClass("active");
            $("#gallery-button").addClass("active");
            $('.image-gallery').show();
            $('.video-highlight').hide();
          });
        } else {
          $('.image-gallery').show();
          $('.video-highlight').show();
        }
      }).resize();
    },

    videoField: function (context) {

      /**
       * Video iframe SRC manipulation
       * @type {[type]}
       */
      var $video_tout_field = $(".video-container");

      /**
       * Video button click handler.
       */
      $video_tout_field.click(function (ev) {
        var $trigger = $(this),
          $video_tout = $("iframe", $trigger);

        $(".field--name-field-background-image", $trigger).addClass("hidden").fadeOut(2000);
        $(".field--name-thumbnail", $trigger).addClass("hidden").fadeOut(2000);
        $(".field--name-name", $trigger).addClass("hidden").fadeOut(2000);

        var video_src = $video_tout.attr("src"),
          new_src = video_src.replace("autoplay=0", "autoplay=1");

        $video_tout.attr("src", new_src).attr("allow", "autoplay");

        ev.preventDefault();
      });

    },

    restaurantListingAll: function (context) {

      $(window).on('resize load', function () {
        var $grid = $('#block-views-block-restaurant-all-restaurants .view-display-id-all_restaurants .view-content').isotope({
          // main isotope options
          itemSelector: '.views-row-wrapper',
          // options for masonry layout mode
          masonry: {
            columnWidth: '.views-row-wrapper',
            gutter: 30,
            horizontalOrder: true
          }
        });
      });

      $(document).ready(function () {
        $("#block-views-block-restaurant-all-restaurants .view-display-id-all_restaurants .view-filters").each(function () {
          $('#block-entityviewcontent-header .view-filters').remove();
          $(this).addClass("all-restaurants-filters");
          $(this).insertAfter(".header-search-title");
        });
      });

    },

    restaurantListing: function (context) {

      $(window).on('resize load', function () {
        var $grid = $('#block-views-block-restaurant-listing-restaurants-by-venuetype .view-display-id-restaurants_by_venuetype .view-content').isotope({
          // main isotope options
          itemSelector: '.views-row-wrapper',
          // options for masonry layout mode
          masonry: {
            columnWidth: '.views-row-wrapper',
            gutter: 30,
            horizontalOrder: true
          }
        });
      });

      $(document).ready(function () {
        $("#block-views-block-restaurant-listing-restaurants-by-venuetype .view-display-id-restaurants_by_venuetype .view-filters").each(function () {
          $('#block-entityviewcontent-header .view-filters').remove();
          $(this).addClass("restaurants-filters");
          $(this).insertAfter(".header-search-title");
        });

        $('#block-entityviewcontent-upper-body .node--view-mode-upper-body').each(function () {
          if (!($(this).text() || '').trim()) {
            $(this).addClass('empty');
          } else {
            $(this).removeClass('empty');
          }
        });
      });

    },

    meetingEventListing: function (context) {

      $(window).on('resize load', function () {
        var $grid = $('#block-views-block-meetings-and-events-meetings-party-venues .view-display-id-meetings_party_venues .view-content').isotope({
          // main isotope options
          itemSelector: '.views-row-wrapper',
          // options for masonry layout mode
          masonry: {
            columnWidth: '.views-row-wrapper',
            gutter: 30,
            horizontalOrder: true
          }
        });
      });
    },

    searchPage: function (context) {

      $(window).on('resize load', function () {
        var $grid = $('.view-display-id-restaurant_search .view-content').isotope({
          // main isotope options
          itemSelector: '.views-row-wrapper',
          // options for masonry layout mode
          masonry: {
            columnWidth: '.views-row-wrapper',
            gutter: 30,
            horizontalOrder: true
          }
        });
      });
    },

    langSwitchMobileText: function (context) {
      $(window).on('resize load', function () {
        if ($(window).width() < 940) {
          $("a.language-link[hreflang|='fi']").addClass("fi-text").removeClass("en-text");
          $("a.language-link[hreflang|='en']").addClass("en-text").removeClass("fi-text");
        } else {
          $("a.language-link").removeClass("fi-text en-text");
        }
      }).resize();
    },

    restaurantListingDropdown: function (context) {
      $(window).on("resize load", function () {
        if ($(window).width() <= 719) {
          $("#block-submenu .submenu-click").click(function () {
            $("#block-submenu .submenu-click").toggleClass("open");
            $("#block-submenu ul.menu").toggleClass("visible");
          });
        } else {
          $("#block-submenu .submenu-click").unbind("click");
        }
      });
    },

    restaurantOpeningHours: function (context) {
      $('#block-restaurantshowrestaurantweeklymenu .meal-date-tabs').each(function () {
        if (!($(this).html() || '').trim().length) {
          $('#block-restaurant-opening-hours').show();
        } else {
          $('#block-restaurant-opening-hours').hide();
        }
      });

      $('.node--view-mode-opening-hours .regular-hours').click(function (e) {
        $(context).find('.regular-hours-div').slideToggle();
        $(this).toggleClass('js-open');
      });

      $('.node--view-mode-opening-hours .special-hours').click(function (e) {
        $(context).find('.special-hours-div').slideToggle();
        $(this).toggleClass('js-open');
      });

      $(context).find('.node--view-mode-opening-hours .regular-hours-dropdown .close-button').click(function (e) {
        $(context).find('.regular-hours-div').slideToggle();
        $(context).find('.regular-hours').toggleClass('js-open');
      });

      $('.node--view-mode-opening-hours .paragraph--type--restaurant-special-opening-hours').each(function () {
        if (!($(this).html() || '').trim().length) {
          $(this).parent('.field__item').addClass('empty');
        }
      });

      $('.node--view-mode-opening-hours .field--name-field-special-opening-hours').each(function () {
        if ($('.node--view-mode-opening-hours .field--name-field-special-opening-hours .field__item.empty').length === $('.node--view-mode-opening-hours .field--name-field-special-opening-hours .field__item').length) {
          $('.node--view-mode-opening-hours .field--name-field-special-opening-hours').addClass('hide');
        }
        else {
          $('.node--view-mode-opening-hours .field--name-field-special-opening-hours').addClass('show');
        }

        if ($('.node--view-mode-opening-hours .field--name-field-special-opening-hours').hasClass('hide')) {
          $('.node--view-mode-opening-hours .special-hours-dropdown').hide();
        }
      });

    },

    restaurantContentMenu: function (context) {

      $(" #block-restaurantcontentmenublock .toggle-mobile-menu").click(function (ev) {
        $(this).parent().toggleClass('open');
      });

    },

    morePics: function (context) {
      $(context).find('.more-pics-indicator').click(function (e) {
        $(context).find('.field--name-field-images .field__item:first-of-type .field--name-field-media-image a').click();
      });
    },

    attach: function (context, settings) {
      Drupal.behaviors.sodexo.frontPageHero();
      Drupal.behaviors.sodexo.frontPageListings();
      Drupal.behaviors.sodexo.newsPageListing();
      Drupal.behaviors.sodexo.newsCampaignListing();
      Drupal.behaviors.sodexo.restaurantNCListing();
      Drupal.behaviors.sodexo.rtMenu();
      Drupal.behaviors.sodexo.restaurantPage();
      Drupal.behaviors.sodexo.videoField();
      Drupal.behaviors.sodexo.restaurantListingAll();
      Drupal.behaviors.sodexo.restaurantListing();
      Drupal.behaviors.sodexo.meetingEventListing();
      Drupal.behaviors.sodexo.searchPage();
      Drupal.behaviors.sodexo.langSwitchMobileText();
      Drupal.behaviors.sodexo.restaurantListingDropdown();
      Drupal.behaviors.sodexo.restaurantOpeningHours(context);
      Drupal.behaviors.sodexo.restaurantContentMenu();
      Drupal.behaviors.sodexo.morePics(context);
    }
  };
})(jQuery, Drupal);
